<template lang="pug">
    section.informacoes
        ul.items
            li(v-for="item in content").item
                small {{ item.title }}
                p {{ item.info }}
            li.icon
                SvgIcon(data="@svgs/logos/arvore.svg")
        router-link(:to="{name: 'pagina', params: {slug: 'contato' } }") Agendar visita
</template>

<script>
export default {
    name: "component-informacoes",
    props: {
        content: {
            type: Array,
            required: true
        }
    },
}
</script>

<style lang="stylus" scoped src="./Informacoes.styl"></style>